export interface ArticleItem {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  excerpt: string;
  content: string;
  author: string;
  date: string;
  imageSeq: string;
  tags: string[];
  views: number;
}

export const articles: ArticleItem[] = [
  {
    id: 'article-1',
    title: '2026年最值得期待的十部国产电影，每一部都不容错过',
    category: '电影资讯',
    categorySlug: 'movie',
    excerpt: '2026年国产电影市场热闹非凡，从科幻大片到动画巨制，从历史史诗到现实主义力作，本文将为您盘点今年最值得期待的十部国产电影。',
    content: `<p>2026年，中国电影市场迎来了前所未有的繁荣。随着电影工业的不断成熟和创作人才的涌现，越来越多的优秀国产电影正在走向大银幕。本文将为您盘点今年最值得期待的十部国产电影。</p>
<h3>1. 《流浪地球3》</h3>
<p>作为中国科幻电影的标杆之作，《流浪地球》系列第三部将继续讲述人类带着地球在宇宙中流浪的故事。导演郭帆表示，第三部将在视觉效果和故事深度上全面升级，为观众带来更加震撼的观影体验。</p>
<h3>2. 《长安三万里2》</h3>
<p>前作以独特的动画风格和深厚的文化底蕴征服了无数观众，续集将继续探索大唐诗人们的传奇人生。追光动画在美术风格和叙事手法上都有了新的突破。</p>
<h3>3. 《封神第二部》</h3>
<p>乌尔善导演的封神三部曲持续发力，第二部将深入展现封神大战的宏大场面。精良的特效制作和对中国传统神话的现代诠释是这部作品最大的看点。</p>
<h3>4. 《哪吒3》</h3>
<p>饺子导演的哪吒系列第三部终于要来了！经过前两部的铺垫，哪吒的故事将迎来新的高潮。据悉第三部在制作规模上将有质的飞跃。</p>
<p>除此之外，还有多部现实主义题材作品和独立电影值得关注。2026年，中国电影正在用多元化的内容满足不同观众的需求，让我们共同期待这些优秀作品的到来。</p>`,
    author: '黄瓜影院编辑部',
    date: '2026-08-06',
    imageSeq: 'article-cover-01',
    tags: ['电影', '盘点', '2026', '国产电影'],
    views: 15820,
  },
  {
    id: 'article-2',
    title: '《庆余年第二季》深度解析：范闲的命运转折与朝堂博弈',
    category: '电视剧评',
    categorySlug: 'tv',
    excerpt: '《庆余年第二季》口碑持续走高，范闲在朝堂与江湖之间的精彩博弈让观众大呼过瘾。本文将从剧情、人物和主题三个维度深度解析这部现象级作品。',
    content: `<p>《庆余年第二季》自开播以来，凭借精良的制作和扎实的剧本赢得了观众的广泛好评。本文将深入分析这部剧集的核心看点。</p>
<h3>剧情架构：权谋与人性的双重博弈</h3>
<p>第二季的剧情明显比第一季更加复杂。范闲不再只是一个想要安稳生活的穿越者，而是被迫卷入了更加深层的政治斗争。编剧巧妙地将个人命运与国家大局交织在一起，每一集都充满了悬念和反转。</p>
<h3>人物塑造：群像戏的精湛呈现</h3>
<p>除了主角范闲，第二季中的配角也得到了更加充分的刻画。陈萍萍的老谋深算、庆帝的帝王心术、范建的家国情怀，每个角色都有自己鲜明的性格和动机。</p>
<h3>制作水准：国产剧的新标杆</h3>
<p>从服化道到场景搭建，从摄影到配乐，《庆余年第二季》的制作水准达到了国产剧的新高度。尤其是几场大型朝堂戏的调度，堪称教科书级别。</p>
<p>总的来说，《庆余年第二季》不仅在商业上取得了成功，在艺术表现上也展现了国产剧的进步。期待后续剧情的精彩发展。</p>`,
    author: '影视观察员小王',
    date: '2026-08-05',
    imageSeq: 'article-cover-02',
    tags: ['庆余年', '剧评', '古装剧', '深度解析'],
    views: 23450,
  },
  {
    id: 'article-3',
    title: '国漫崛起：从《凡人修仙传》到《完美世界》，国产动画的黄金时代',
    category: '动漫资讯',
    categorySlug: 'anime',
    excerpt: '近年来国产动画质量突飞猛进，《凡人修仙传》《完美世界》《斗破苍穹》等作品在国内外都获得了极高评价。国漫正在迎来属于自己的黄金时代。',
    content: `<p>如果说十年前还有人质疑国产动画的质量，那么今天这些质疑已经被一部部优秀作品彻底打破。从技术到叙事，国漫正在经历一场全面的升级。</p>
<h3>技术突破：从2D到3D的全面进化</h3>
<p>以《凡人修仙传》为代表的3D动画，在角色建模、动作捕捉和场景渲染方面已经达到了国际水准。尤其是战斗场面的表现力，完全不输给日本和好莱坞的同类作品。</p>
<h3>IP改编：网络文学的金矿</h3>
<p>中国拥有世界上最丰富的网络文学资源。《斗破苍穹》《完美世界》《仙逆》等热门网文IP为动画提供了源源不断的优质内容。这些原作拥有庞大的粉丝基础，改编动画自然备受关注。</p>
<h3>文化自信：中国美学的现代诠释</h3>
<p>国漫不仅仅是模仿，更在探索属于中国自己的动画美学。从水墨风格到传统服饰，从古典建筑到东方哲学，国漫正在用现代技术重新诠释中国传统文化之美。</p>
<p>国漫的黄金时代才刚刚开始，未来可期。</p>`,
    author: '动漫达人阿杰',
    date: '2026-08-04',
    imageSeq: 'article-cover-03',
    tags: ['国漫', '动画', '凡修', '完美世界'],
    views: 18920,
  },
  {
    id: 'article-4',
    title: '综艺节目新风向：《奔跑吧》《向往的生活》如何持续吸引观众',
    category: '综艺资讯',
    categorySlug: 'variety',
    excerpt: '在短视频冲击下，传统综艺节目面临着前所未有的挑战。然而《奔跑吧》《向往的生活》等老牌综艺依然保持着高收视率，它们成功的秘诀是什么？',
    content: `<p>在内容消费碎片化的时代，长视频综艺如何在激烈的注意力竞争中生存下来？本文将以《奔跑吧》和《向往的生活》为例，分析老牌综艺的长青之道。</p>
<h3>内容创新：不断进化的节目模式</h3>
<p>《奔跑吧》每一季都会引入新的游戏环节和挑战模式，避免了观众的审美疲劳。而《向往的生活》则在保持田园生活基调的同时，不断邀请不同类型的嘉宾，为节目注入新鲜感。</p>
<h3>情感连接：从娱乐到陪伴</h3>
<p>成功的综艺节目不仅仅是娱乐，更是一种情感陪伴。观众与节目中的嘉宾建立了深厚的情感连接，每周固定时间收看已经成为一种生活习惯。</p>
<h3>社交媒体互动：打破屏幕界限</h3>
<p>节目组充分利用社交媒体与观众互动，节目中的名场面和话题梗在微博、抖音等平台持续发酵，形成了强大的二次传播效应。</p>
<p>综艺节目的未来在于不断创新和与观众建立更深层次的情感连接。</p>`,
    author: '黄瓜影院编辑部',
    date: '2026-08-03',
    imageSeq: 'article-cover-04',
    tags: ['综艺', '奔跑吧', '向往的生活', '收视率'],
    views: 12340,
  },
  {
    id: 'article-5',
    title: '《三体》电视剧改编：如何将科幻巨著搬上荧幕',
    category: '电视剧评',
    categorySlug: 'tv',
    excerpt: '作为中国科幻文学的巅峰之作，《三体》的影视化改编一直备受关注。电视剧版《三体》播出后引发热议，本文将探讨这部作品的改编之路。',
    content: `<p>刘慈欣的《三体》被誉为中国科幻文学的里程碑。将这样一部思想深邃、世界观宏大的作品改编成电视剧，无疑是一个巨大的挑战。</p>
<h3>忠实与创新：改编的平衡艺术</h3>
<p>电视剧《三体》在忠实原著和影视化创新之间找到了一个相对平衡的点。保留了原著的科学内核和哲学思考，同时在叙事节奏上做了适合电视剧观众的调整。</p>
<h3>视觉呈现：科幻美学的中国方案</h3>
<p>《三体》的视觉效果让人眼前一亮。三体游戏世界的光怪陆离、智子展开的震撼场面，都展现了中国科幻视觉特效的进步。</p>
<h3>文化意义：中国科幻的里程碑</h3>
<p>《三体》电视剧的成功不仅是商业上的，更是文化意义上的。它证明了中国人也能讲好自己的科幻故事，为后续的科幻影视创作打开了大门。</p>`,
    author: '科幻迷老李',
    date: '2026-08-02',
    imageSeq: 'article-cover-05',
    tags: ['三体', '科幻', '剧评', '刘慈欣'],
    views: 27100,
  },
  {
    id: 'article-6',
    title: '暑期档观影指南：全家老少都适合的合家欢电影推荐',
    category: '电影资讯',
    categorySlug: 'movie',
    excerpt: '暑期档来临，不少家庭选择走进影院享受亲子时光。本文精选了五部适合全家观看的合家欢电影，涵盖动画、喜剧和冒险等多种类型。',
    content: `<p>暑期档是电影市场的黄金档期，也是家庭观影的高峰期。如何选择一部适合全家老少一起看的电影？本文为您推荐五部不错的选择。</p>
<h3>1. 《长安三万里2》</h3>
<p>精美的动画画面和深厚的文化内涵，让孩子在娱乐中了解中国传统文化的魅力。大人也能从中获得共鸣和感动。</p>
<h3>2. 《深海2》</h3>
<p>绚丽的粒子水墨画面和温暖治愈的故事，适合各个年龄段的观众。影片传递的关于勇气和爱的主题具有普世价值。</p>
<h3>3. 《熊出没·逆转时空》</h3>
<p>国产动画的常青树IP，光头强和熊大熊二的冒险故事总能给孩子带来欢乐。影片融入了科幻元素，让故事更加有趣。</p>
<p>无论选择哪一部，最重要的是全家一起享受这段美好的观影时光。</p>`,
    author: '黄瓜影院编辑部',
    date: '2026-08-01',
    imageSeq: 'article-cover-06',
    tags: ['暑期档', '合家欢', '动画电影', '观影指南'],
    views: 9870,
  },
];

export const getArticlesByCategory = (categorySlug: string): ArticleItem[] => {
  return articles.filter((a) => a.categorySlug === categorySlug);
};

export const getArticleById = (id: string): ArticleItem | undefined => {
  return articles.find((a) => a.id === id);
};

export const getLatestArticles = (limit: number = 6): ArticleItem[] => {
  return [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, limit);
};